import { useGetAccountOpeningProductsQuery } from "@lending/hooks/queries/useGetAccountOpeningProductsQuery";
import { useGetInstitutionQuery } from "@lending/hooks/queries/useGetInstitutionQuery";

function useMembershipShareProduct() {
  const { institution } = useGetInstitutionQuery();
  const { products } = useGetAccountOpeningProductsQuery();

  const membershipShareProduct = products?.find(
    (product) =>
      product.id === institution.membership_share_product_for_lending ||
      product.uuid === institution.membership_share_product_for_lending
  );

  return { membershipShareProduct };
}

export { useMembershipShareProduct };
